// extracted by mini-css-extract-plugin
export default {"aside__section":"day_trending_aside__section__r+8wM","aside__title":"day_trending_aside__title__o3haH","aside__section_cards":"day_trending_aside__section_cards__bPE8y"};